<template>
    <glass-panel
        radius="lg"
        class="pa-8"
    >
        <div class="d-flex align-center justify-space-between mb-6">
            <h3 class="card-title-strong">{{ title }}</h3>
            <button
                v-if="actionLabel"
                class="eyebrow eyebrow-primary"
                style="background:none;border:none;cursor:pointer"
                @click="$emit('action')"
            >
                {{ actionLabel }}
            </button>
        </div>
        <div style="display:flex;flex-direction:column;gap:24px">
            <slot>
                <activity-item
                    v-for="(item, i) in items"
                    :key="i"
                    :title="item.title"
                    :description="item.description"
                    :time="item.time"
                    :icon="item.icon || 'mdi-circle-medium'"
                    :icon-color="item.iconColor || 'primary'"
                />
            </slot>
            <div
                v-if="(!$slots.default && !items.length)"
                class="body-sm text-faint"
            >
                Sem atividades por enquanto.
            </div>
        </div>
    </glass-panel>
</template>

<script>
export default {
    name: 'ActivityList',
    props: {
        title: { type: String, default: 'Registro de ações recentes' },
        actionLabel: { type: String, default: 'Ver todos' },
        items: { type: Array, default: () => [] },
    },
}
</script>
